<div class="container">
  <h2 class="title text-center">Tabela de Submissão</h2>

  <p class="text-justify">
    Nesta página, apresentamos a relação dos cursos que foram excluídos ou não foram incluídos no Catálogo, também conhecida como tabela de submissão. Esses cursos se tornaram obsoletos, têm algum conflito com a legislação trabalhista, têm sombreamento com outros cursos ou ainda, são especializações de outros cursos.
  </p>
  <p class="text-justify">
    RRecomenda-se aos órgãos competentes que não autorizem, como experimentais, cursos cujas denominações constem nesta tabela, conforme teor da
    <a
      class="link custom-link"
      target="_blank"
      href="http://portal.mec.gov.br/index.php?option=com_docman&view=download&alias=16705-res1-2014-cne-ceb-05122014&category_slug=dezembro-2014-pdf&Itemid=30192"
      >Resolução CNE/CEB nº 01/2014</a
    >.
  </p>
  <br />
  <a
    routerLink="/cursos"
    [queryParams]="{ filtro: 'naopermitidos' }"
    class="btn-primary link btn btn-xl rounded-pill text-center"
    >Ir para esses cursos</a
  >
</div>
